// app.component.ts
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { AuthenticationService } from './services/authentication.service';
import { StatusBar, Style } from '@capacitor/status-bar';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private authService: AuthenticationService,
    private router: Router
  ) {
    this.initializeApp();
  }

  async initializeApp() {
    await this.platform.ready();

    StatusBar.setOverlaysWebView({ overlay: true });
    StatusBar.setStyle({ style: Style.Dark });

    this.authService.authenticationState.subscribe((state) => {
      console.log('👂 AuthState cambio:', state);
      if (state) {
        console.log('➡️ Navegando a /members');
        this.router.navigateByUrl('/members', { replaceUrl: true });
      } else {
        console.log('➡️ Navegando a /');
        this.router.navigateByUrl('/', { replaceUrl: true });
      }
    });
  }
}
